var React = require('react');

function StreamlineIconCheckCircle1Alternate (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"},React.createElement("g",null,[React.createElement("path",{"d":"M18.48,6.45a1.26,1.26,0,0,0-1.75.26l-5.92,8L7,11.74a1.25,1.25,0,1,0-1.56,1.95l4.78,3.83a1.26,1.26,0,0,0,1.79-.24L18.74,8.2A1.25,1.25,0,0,0,18.48,6.45Z","key":0}),React.createElement("path",{"d":"M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z","key":1})])));
}

StreamlineIconCheckCircle1Alternate.defaultProps = {"viewBox":"0 0 140 140"};

module.exports = StreamlineIconCheckCircle1Alternate;

StreamlineIconCheckCircle1Alternate.default = StreamlineIconCheckCircle1Alternate;
